import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';
import Modal_Empleados from './modal_empleados';
import Modal from 'react-modal';
import Alert from 'react-s-alert';


const database=firebase.database();


const customStyles = {
  content : {
    top                   : '80%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class ReporteConductores extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			conductores:[],
			vehiculos:[],
			vehiculo1:[],
			isActive:false,
			template:false,
			files:null
			
		}		
		
		this.empleadosRef=database.ref().child('Empleados').orderByChild('socio').equalTo(firebase.auth().currentUser.uid);
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.toggleModalUpdate=this.toggleModalUpdate.bind(this);
		this.llenar=this.llenar.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
	}
	
	componentDidMount(){
		
		
		this.vehiculosRef.on('value',this.gotDataVehiculos,this.errDataVehiculos);
		
		

	}
	
	componentWillMount(){
		
		this.vehiculosRef.on('value',this.gotDataVehiculos,this.errDataVehiculos);
		
		
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	
	handleClickClose(){		
		Alert.closeAll();
	}
	
	
	
	updateRow=()=>{
			
			
		
		if(this.state.vehiculoKey===undefined){
			this.state.vehiculoKey=this.state.vehiculoAnterior;		
		}
	
	
		//Archivo de la imagen
	   let archivo=this.state.files;
	
	   let nodoHijo=this.keyRow.value;
	
	
	   //Datos del empleado
	   let nombre=this.nombreEmpleado.value;
	   let dui=this.duiEmpleado.value;
	   let edad=this.edadEmpleado.value;
	   let telefono=this.telefonoEmpleado.value;
	   let vehiculo=this.state.vehiculoKey;
	   let socio=firebase.auth().currentUser.uid;
	   let licencia=this.licenciaEmpleado.value;
	   let estado=this.estado.value;
	   
	   
		if(archivo===null)
		{
				
			database.ref().child('Empleados').child(nodoHijo).update({
			   
			   nombre:nombre,
			   dui:dui,
			   edad:edad,
			   telefono:telefono,
			   socio:socio,
			   licencia:licencia,
			   vehiculo:vehiculo,
			   estado:estado
			});
			Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
			
			this.toggleModalUpdate();
			
		}
		else{
			
			const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);
		
			const task= storageRef.put(archivo);
		
		
			task.on('state_changed', snapshot =>{
		
		
					this.setState({
					  uploadValue :50,
					})

			}, error =>{ console.log(error.message);
			},
			()=>{
			
					this.empleadosRef.child(nodoHijo).update({
					   
						nombre:nombre,
						dui:dui,
						edad:edad,
						telefono:telefono,
						socio:socio,
						licencia:licencia,
						vehiculo:vehiculo,
						foto:task.snapshot.downloadURL
						
		
					   //licencia:licencia
					   
					});			 
					
					this.setState({
						uploadValue:100
					});

					
					Alert.success('Datos actualizados correctamente', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
					});	

					this.toggleModalUpdate();
			});
		
		}
		
		
		try{
								
					this.vehiculosRef.child(this.state.vehiculoAnterior).update({
						estado:'Disponible'
					});
					this.vehiculosRef.child(this.state.vehiculoKey).update({
	
						estado:'Asignado'
					});
			
		}
		catch(err){
			
			console.log(err);
		}
		
		
	}
	
	
	gotDataEmpleados=(data)=>{
		let newEmpleados=[]
		
		if(data.val()!==null){
			let empleado=data.val();
			let keys=Object.keys(empleado);

			
			for(let i=0;i<keys.length;i++){
				let k=keys[i];
				
				
				let vehiculo='';
			
				for(let j=0;j<this.state.vehiculos.length;j++){
					
					if(this.state.vehiculos[j].key===empleado[k].vehiculo){
						
						vehiculo=this.state.vehiculos[j].marca+' '+this.state.vehiculos[j].modelo;
						
					}
					
					
				}


				newEmpleados.push({
					key:k,
					correo:empleado[k].correo,
					dui:empleado[k].dui,
					edad:empleado[k].edad,
					estado:empleado[k].estado,
					foto:empleado[k].foto,
					licencia:empleado[k].licencia,
					nombre:empleado[k].nombre,
					socio:empleado[k].socio,
					telefono:empleado[k].telefono,
					tipo_vehiculo:empleado[k].tipo_vehiculo,
					vehiculo:empleado[k].vehiculo,
					vehiculom:vehiculo
					
				})
			}
			this.setState({conductores:newEmpleados})
		}
	}
	errDataEmpleados=(err)=>{		
		console.log(err);
	}
	
	gotDataVehiculos=(data)=>{
		let newVehiculos=[]
		
		if(data.val()!==null){
			
			let vehiculo=data.val();
			let keys=Object.keys(vehiculo);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				

				newVehiculos.push({
					key:k,
					anio:vehiculo[k].anio,
					base:vehiculo[k].base,
					codigo_socio:vehiculo[k].codigo_socio,
					estado:vehiculo[k].estado,
					foto:vehiculo[k].foto,
					marca:vehiculo[k].marca,
					modelo:vehiculo[k].modelo,
					placa:vehiculo[k].placa,
					tipo_vehiculo:vehiculo[k].tipo_vehiculo
					
				})
				
			}
			this.setState({
				vehiculos:newVehiculos,
				vehiculos1:newVehiculos
				})
			this.empleadosRef.on('value',this.gotDataEmpleados,this.errDataEmpleados);
		}
	}
	errDataVehiculos=(err)=>{		
			console.log(err);
	}
	
	handleClick = (rowKey) => {
		
		this.llenar();
		let vehiculostemp=[];
		let marca='';
		let modelo='';
		
		
		for(let i=0;i<this.state.vehiculos.length;i++)
		{
			
			
			if(this.state.vehiculos[i].key===rowKey.vehiculo)
			{
				
				
				marca=this.state.vehiculos[i].marca;
				modelo=this.state.vehiculos[i].modelo;	
			}		
		}
				
		
		this.setState({
		    keyRow:rowKey.key,
			direccion:rowKey.direccion,
			dui:rowKey.dui,
			edad:rowKey.edad,
			licencia:rowKey.licencia,
			latitud:rowKey.latitud,
			longitud:rowKey.longitud,
			nombre:rowKey.nombre,
			placa:rowKey.placa,
			vehiculoAnterior:rowKey.vehiculo,
			vehiculo:rowKey.vehiculo,
			socio:rowKey.socio,
			telefono:rowKey.telefono,
			foto:rowKey.foto,
			nombreSocio:rowKey.nombreSocio,
			marca:marca,
			modelo:modelo,
			vehiculos:vehiculostemp,
			estado:rowKey.estado
		});
	  
		this.toggleModalUpdate();
	}
	
	llenar(){
			
		this.state.vehiculos=this.state.vehiculos1
	}
	
	
	toggleModalUpdate=()=>{
		
		this.setState({
			uploadValue:0,
			isActive:!this.state.isActive
		})		
	}
	
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	btnVehiculosFormatter(cell,row){
		
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickVehiculos(row)}} >Seleccionar</button>;
	}

	
	handleClickVehiculos=(rowKey)=>{
		
		this.setState({
			
			vehiculoKey:rowKey.key,	
			marca:rowKey.marca+' ',
			modelo:rowKey.modelo
		});
		
		this.toggleModalVehiculos();
		
	}
	
	
	toggleModalVehiculos=()=>{
					
			this.setState({
				isActiveVehiculos:!this.state.isActiveVehiculos
			
			})	
	}
	
	render(){
		
		return(
		
		
		
					
				<div className="reporte_conductores container">
					
					<h1 className="titulo">Conductores</h1>
					
					<Modal_Empleados/>
					{this.state.template ? <Alert  timeout='none' stack={{limit: 1}} contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 1}} html={true} />}
					<BootstrapTable data={ this.state.conductores }
						 ref='table'			 
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre'  dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='correo'  dataSort={true}  >Correo</TableHeaderColumn>
						 <TableHeaderColumn dataField='dui'  dataSort={true}  >Dui</TableHeaderColumn>
						 <TableHeaderColumn dataField='licencia'  dataSort={true}  >Lincecia</TableHeaderColumn>						 
						 <TableHeaderColumn dataField='telefono'  dataSort={true}  >Telefono</TableHeaderColumn>
						 <TableHeaderColumn dataField='vehiculom'  dataSort={true}  >Vehiculo</TableHeaderColumn>
						 <TableHeaderColumn dataField='tipo_vehiculo'  dataSort={true}  >Tipo Vehiculo</TableHeaderColumn>
						 		 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
					</BootstrapTable>
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>

						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
			  
								<h3>Modificar Empleado</h3>
								<hr/>
								<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
								<div className="form-group">
										<label htmlFor="nombre" >Nombre:</label>
										<input type="text" className="form-control" name="nombre" 
											ref={input => {this.nombreEmpleado=input;}}
											onKeyPress={this.handleKeyPressLetras}
											placeholder="Nombre"
											required
										defaultValue={this.state.nombre}
										/>
									</div>
									<div className="form-group">
										<label htmlFor="dui" >Dui:</label>
										<input type="text" className="form-control" name="dui" 
											ref={input => {this.duiEmpleado=input;}}
											onKeyPress={this.handleKeyPressDui}
											maxLength="10" minLength="10"
											placeholder="Dui"
											required
										defaultValue={this.state.dui}
										/>
									</div>
									<div className="form-group">
										<label htmlFor="edad" >Edad:</label>
										<input type="text" className="form-control" name="edad" 
											ref={input => {this.edadEmpleado=input;}}
											onKeyPress={this.handleKeyPressNumeros}
											placeholder="Edad"
											maxLength="2" minLength="2"
											autoComplete="off" required
										defaultValue={this.state.edad}
										/>
									</div>
									
									<div className="form-group">
										<label htmlFor="licencia">Licencia</label>
										<input type="text" className="form-control" name="licencia"
											ref={input => {this.licenciaEmpleado=input;}}
											placeholder="Licencia" required
											autoComplete="off"
											defaultValue={this.state.licencia}										
											onKeyPress={this.handleKeyPressLicencia}
											maxLength="17" minLength="17"
										/>
									</div>
									
									<div className="form-group">
										<label  htmlFor="telefono" >Telefono:</label>
										<input 		type="text" className="form-control" name="capacidad"
											ref={input => {this.telefonoEmpleado=input;}}
											minLength="8" maxLength="8"
											placeholder="Telefono"
											autoComplete="off" required
											onKeyPress={this.handleKeyPressNumeros}
										defaultValue={this.state.telefono}
										/>
									</div>
									
								
									<div className="form-group">
										<label  htmlFor="placa" >Vehiculo:</label>
										<input type="text" className="form-control" name="placa"
											ref={input => {this.placaEmpleado=input;}}
											placeholder="Placa"
											autoComplete="off" required
					      					value={this.state.marca+' '+this.state.modelo}
											onClick={this.toggleModalVehiculos}
											readOnly="readOnly"
										/>
									</div>
									
									<div className="form-group">
										<label htmlFor="estado">Estado</label>
										<select name="estado" className="form-control" 
											ref={input=>{this.estado=input;}}
											defaultValue={this.state.estado}
										>
											<option>activo</option>
											<option>desactivo</option>
										</select>
									</div>
									
									
									<div className="form-group">
										<label htmlFor="foto">Foto del conductor</label>
										<br/>
										<progress value={this.state.uploadValue} max="100"></progress>
										<input type="file" className="form-control"  onChange={this.handleUpload}/>
									</div>
									<img src={this.state.foto} alt="Foto del conductor" className="foto" width="240px"/>
								<hr/>
								<button className="btn btn-primary buttons" type="submit">Guardar</button>
								
						</form>
								<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal> 
					
									<Modal isOpen={this.state.isActiveVehiculos} onRequestClose={this.toggleModalVehiculos}  style={customStyles}>
						<h4>Selecciona un vehiculo</h4>
						<hr/>
					
					
							<BootstrapTable data={ this.state.vehiculos}
								 ref='table'
								 pagination={ true }
								 search={ true }
								 hover
								 >
								<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn dataField='marca' dataSort={true}>Marca</TableHeaderColumn>
								<TableHeaderColumn dataField='modelo' dataSort={true}>Modelo</TableHeaderColumn>
								<TableHeaderColumn dataField='placa'>Placa</TableHeaderColumn>
	
								 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnVehiculosFormatter.bind(this) }>Editar</TableHeaderColumn>
							</BootstrapTable>								
						
					</Modal>
					
					
				</div>
		
		);		
	}	
}

export default ReporteConductores;


// WEBPACK FOOTER //
// ./src/Components/Perfil_Socios/ReporteConductores.jsx